import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  selectDisablePromotionSection,
  selectIsPromotionPackageSelected,
  selectIsUnavailableImportOfferPromotionForSelfMoneySource,
} from '../../../../selectors/publishTerms';
import { selectPromotionCost } from '../../../../selectors/checkoutInfo';
import { EPlacingLayoutType } from './types';
import { BetInputContainer } from './components/BetInput';
import { BetInputLabel } from './components/BetInputLabel';
import { PackagesLayout } from './components/PackagesLayout';
import { PromotionCost } from './components/PromotionCost';
import { ServicesLayout } from './components/ServicesLayout';
import { ServiceErrorContainer } from './components/ServiceError';
import { selectIsAuctionEnabled } from '../../../../selectors/auction';
import { PackagesWithoutBetLayout } from './components/PackagesWithoutBetLayout';
import { TermsDurationsContainer } from './components/TermsDurations';
import { getCurrentLayout } from './utils';
import { selectIsTermsDurationsAvailable } from '../../../../selectors/termsDurations';
import { ImportOfferPromotionUnavailable } from './components/ImportOfferPromotionUnavailable';
import { ServicesContainer } from './components/Services';
import { PromotionContainer } from './components/Promotion';

export const PromotionSectionContainer = () => {
  const isPromotionPackageSelected = useSelector(selectIsPromotionPackageSelected);
  const isAuctionEnabled = useSelector(selectIsAuctionEnabled);
  const promotionCost = useSelector(selectPromotionCost);

  const isTermsDurationsAvailable = useSelector(selectIsTermsDurationsAvailable);

  const isImportOfferPromotionForSelfMoneySourceUnavailable = useSelector(
    selectIsUnavailableImportOfferPromotionForSelfMoneySource,
  );

  const currentLayout = getCurrentLayout({ isPromotionPackageSelected, isAuctionEnabled });

  const allowDisablePromotionSection = useSelector(selectDisablePromotionSection);

  if (isImportOfferPromotionForSelfMoneySourceUnavailable) {
    return <ImportOfferPromotionUnavailable />;
  }

  return (
    <>
      {currentLayout === EPlacingLayoutType.packagesWithoutBet && (
        <PackagesWithoutBetLayout promotion={<PromotionContainer />} error={<ServiceErrorContainer />} />
      )}

      {currentLayout === EPlacingLayoutType.packages && (
        <PackagesLayout
          promotion={<PromotionContainer />}
          betInputLabel={<BetInputLabel />}
          betInput={<BetInputContainer />}
          promotionCost={<PromotionCost promotionCost={promotionCost} />}
          error={<ServiceErrorContainer />}
        />
      )}

      {currentLayout === EPlacingLayoutType.services && (
        <ServicesLayout services={<ServicesContainer />} error={<ServiceErrorContainer />} />
      )}

      {isTermsDurationsAvailable && !allowDisablePromotionSection && <TermsDurationsContainer />}
    </>
  );
};
